import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Translation, TranslocoLoader } from "@jsverse/transloco";

@Injectable({ providedIn: "root" })
class TranslocoHttpLoader implements TranslocoLoader {
	readonly #http = inject(HttpClient);

	getTranslation(lang: string) {
		return this.#http.get<Translation>(`i18n/${lang}.json`, {
			headers: { "is-config": "true" },
		});
	}
}

export default TranslocoHttpLoader;
